export default {
  IMAGE: 0,
  VIDEO: 1,
}
